import moment from 'moment';

import today from './today';

const MINUTES_IN_DAY = 1440;
export const TIME_STEP = 30;

export default function times(minutesStep?: number): Date[] {
  const step = minutesStep ? minutesStep : TIME_STEP;
  const count = MINUTES_IN_DAY / step; // 48 "times" for DEFAULT_MINUTES_STEP
  const m = moment(today(step));
  const options = [];

  for (let i = 0; i < count; i++) {
    options.push(m.toDate());
    m.add(step, 'm');
  }

  return options;
}
